<script>
  import { selectedLanguage, tr, setLanguage } from '$stores/translationStore';
  import { onMount } from 'svelte';
  import { FontAwesomeIcon } from '@fortawesome/svelte-fontawesome';
  import { faGlobe } from '@fortawesome/pro-light-svg-icons';

  // Using local API endpoints instead of direct API access
  const API_BASE_URL = '/api/proxy';

  // Temporary list of allowed languages
  const ALLOWED_LANGUAGES = ['en_US', 'es_US', 'de_DE'];

  let languages = [];
  let isLoading = true;
  let currentLanguage = 'en_US';

  onMount(async () => {
    await fetchLanguages();
    await fetchTranslations();
  });

  async function fetchLanguages() {
    try {
      const res = await fetch(`${API_BASE_URL}/languages?pageSize=999`);
      if (!res.ok) {
        throw new Error('Failed to fetch languages');
      }
      const data = await res.json();
      // Filter languages to only include allowed ones
      languages = (data.data || []).filter(lang => ALLOWED_LANGUAGES.includes(lang.code));
    } catch (err) {
      console.error('Error fetching languages:', err);
      languages = [];
    } finally {
      isLoading = false;
    }
  }

  async function fetchTranslations() {
    try {
      // console.log('Fetching translations for language:', currentLanguage);
      
      // First fetch all localization entries for Web platform
      const entriesRes = await fetch(`${API_BASE_URL}/localization?platform=Web&pageSize=999`);
      if (!entriesRes.ok) {
        throw new Error('Failed to fetch localization entries');
      }
      const entriesData = await entriesRes.json();
      const entries = entriesData.data || [];
      
      // Then fetch translations for the selected language
      const translationsRes = await fetch(`${API_BASE_URL}/translations?languageCode=${currentLanguage}`);
      if (!translationsRes.ok) {
        throw new Error('Failed to fetch translations');
      }
      const translationsData = await translationsRes.json();
      const translationsList = translationsData.data || [];
      
      // Create a map of translations for easy lookup
      const translationMap = {};
      for (const entry of entries) {
        const translation = translationsList.find(t => t.entryId === entry._id);
        if (translation) {
          translationMap[`${entry.key}|${entry.platforms[0]}`] = translation;
        }
      }
      
      // console.log('Loaded translations:', translationMap);
      tr.set(translationMap);
    } catch (err) {
      console.error('Error fetching translations:', err);
      tr.set({});
    }
  }

  async function handleLanguageChange(event) {
    const newLanguage = event.target.value;
    currentLanguage = newLanguage;
    setLanguage(newLanguage);
    await fetchTranslations();
  }

  // Subscribe to selectedLanguage changes to update local state
  $: if ($selectedLanguage && $selectedLanguage !== currentLanguage) {
    console.log('Language changed from settings:', $selectedLanguage);
    currentLanguage = $selectedLanguage;
    // Fetch translations for the new language
    fetchTranslations();
  }
</script>

<div class="flex items-center gap-2">
  <select
    value={currentLanguage}
    on:change={handleLanguageChange}
    class="h-6 px-2 w-32 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded text-sm text-gray-800 dark:text-gray-100"
    disabled={isLoading}
  >
    {#each languages as language}
      <option value={language.code}>{language.displayLocalized}</option>
    {/each}
  </select>
</div> 